export const GET_USER_DETAIL = "GET_USER_DETAIL";
export const UPDATE_USER_DETAIL = "UPDATE_USER_DETAIL";